<div class="d-flex justify-content-end">
  <div style="padding-top: 1.2rem !important">
    {{'BASE.PAGINATION.SHOW' | translate}}
  </div>
  <div class="page-size mt-2">
    <vss-ui-select-box [optionList]="sizeOptions" [csShowSearch]="false" [(ngModel)]="pageSize" (ngModelChange)="changePageSize($event)" [csAllowClear]="false" class="w-100 custom-page-size"></vss-ui-select-box>
  </div>
  <div class="d-flex ">
    <button nz-button class="me-3" *ngIf="export" (click)="clickExcel()" [nzType]="'primary'" type="button">
    <span nz-icon style="color: hotpink;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>document upload</title><g fill="none" class="nc-icon-wrapper"><path d="M9 17v-6l-2 2" stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9 11l2 2" stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5" stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22 10h-4c-3 0-4-1-4-4V2l8 8z" stroke="red" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
      </span>{{ 'BUTTON.EXPORT_FILE' | translate }}
    </button>
  </div>
  <div class="text-end mt-2 d-flex align-items-center">
    <nz-pagination [nzPageIndex]="currentPage" [nzTotal]="totalItem" [nzSize]="'small'" [nzHideOnSinglePage]="false"
      [nzPageSize]="pageSize" [nzShowQuickJumper]="isShowQuickJumper" [nzShowTotal]="totalTemplate"
      [nzShowSizeChanger]="false" (nzPageSizeChange)="changePageSize($event)"
      [nzPageSizeOptions]="pageSizeOptions" (nzPageIndexChange)="changePageIndex($event)">
    </nz-pagination>
  </div>
</div>
<ng-template #totalTemplate let-total>trên {{totalItem}}</ng-template>

<ng-template #renderItemTemplate let-type let-page="page">
  {{type}}
  <ng-container [ngSwitch]="type">
    <a *ngSwitchCase="'page'">{{ page }}</a>
    <a *ngSwitchCase="'prev'"><i nz-icon nzType="left" nzTheme="outline" class="fs-sm" aria-hidden="true"></i></a>
    <a *ngSwitchCase="'next'"><i nz-icon nzType="right" nzTheme="outline" aria-hidden="true"></i></a>
    <a *ngSwitchCase="'prev_5'"><i nz-icon nzType="left" nzTheme="outline" class="prev" aria-hidden="true"></i> <span class="ant-pagination-item-ellipsis">•••</span></a>
    <a *ngSwitchCase="'next_5'"><i nz-icon nzType="right" nzTheme="outline" class="next" aria-hidden="true"></i><span class="ant-pagination-item-ellipsis">•••</span></a>
  </ng-container>
</ng-template>
